import MyPage from "views/MyPage"
import Favorite from "views/Favorite"

export const privateRouteData = [
    {
        element: <MyPage />,
        url: "/my-page"
    },
    {
        element: <Favorite />,
        url: "/favorite"
    }
]